import React, {forwardRef} from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';

import {ClearIcon} from 'components/common/icons';
import LanguageDropDown from 'components/common/Form/LanguageSelect/LanguageDropDown';

import {TRANSLATE_LANGUAGES, getTranslatedName} from 'components/common/listConstants';

import styles from './LanguageSelect.module.scss';

function LanguageSelect({
    name,
    label,
    error,
    selected,
    className,
    onChange,
    onChangeField,
    options,
    getName = getTranslatedName,
    customTooltipText,
    containerRef,
}) {
    const {t} = useTranslation();
    const languages = options || TRANSLATE_LANGUAGES(t).filter(language => !selected.includes(language.value));

    const onSelect = language => {
        const value = [...selected, language.value];
        if (onChangeField) {
            onChangeField({target: {name, value}});
        } else {
            onChange(value);
        }
    };

    const onRemove = language => {
        const value = selected.filter(l => l !== language);
        if (onChangeField) {
            onChangeField({target: {name, value}});
        } else {
            onChange(value);
        }
    };

    return (
        <div className={cn(styles.languageSelect, className)} ref={containerRef}>
            <LanguageDropDown
                label={label}
                languages={languages}
                onSelect={language => onSelect(language)}
                customTooltipText={customTooltipText}
            />
            {(selected || []).map((language, index) => (
                <div key={index} className={styles.selectedLanguage}>
                    {getName(language, t)}
                    <ClearIcon className={styles.removeIcon} viewBox='6 6 22 22' onClick={() => onRemove(language)} />
                </div>
            ))}
            {error && <div className={styles.error}>{error}</div>}
        </div>
    );
}

export default forwardRef((props, ref) => <LanguageSelect {...props} containerRef={ref} />);
